(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-roll-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      gallery.querySelectorAll('[data-roll-photo-button]').forEach(button => {
        button.addEventListener('click', () => {
          gallery.querySelectorAll('[data-roll-photo]').forEach(photo => {
            photo.hidden = photo.id !== button.dataset.rollPhotoButton;
          });
          gallery.querySelectorAll('[data-roll-photo-button]').forEach(item => {
            item.setAttribute('aria-pressed', String(item === button));
          });
        });
      });
    });
    scope.querySelectorAll('.rpg-closing a').forEach(link => {
      const upload = document.querySelector('[data-ink-artwork-upload]') || document.querySelector('.ink-artwork-upload');
      if (upload?.id) link.href = '#' + upload.id;
      else link.href = '#MainContent';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
